/**
 * 회원 서류 목록 팝업 (/adm/member/doc — layouts/popup)
 * ($j.Pages.Admin.MemberDoc / body data-page-name="MemberDoc")
 *
 * 카드 전체가 편집 진입점이다(이미지 편집기). [서류 이동] 을 켜면 같은 클릭이 '고르기'가 되고,
 * 고른 사진을 다른 서류 칸으로 옮긴다. 회원번호는 루트의 data-mb-no.
 */
export default class MemberDoc {
    initialize() {
        const $root = $('.member-doc');
        this.$root = $root;
        this.mbNo  = Number($root.data('mb-no')) || 0;

        // 카드 전체가 편집 진입점이다 — 예전엔 썸네일과 [수정하기] 버튼이 같은 일을 두 번 했다.
        // 이동 모드에서는 같은 클릭이 '고르기'가 된다.
        $root.on('click keydown', '.md-card', (e) => {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            const $card = $(e.currentTarget);
            if ($root.hasClass('is-moving')) { $card.toggleClass('is-picked'); this.syncMove(); return; }
            this.editPhoto($card.data('num'), $card.data('img'));
        });

        $root.on('click', '.js-set-done', () => this.setDone());

        this.initMove();

        // 이미지 편집기 저장 이벤트 받기
        $j.Common.EventBus.on(G5['NS'], 'img-editor:saved', (e, data) => {
            const imgId = data.imgId;
            const docId = G5['currentEditDocId'];
            $.ajax({
                type: 'POST',
                url: '/adm/ajax/doc/image',   // 관리자 전용 — 회원용 /m/ajax/docs/save 는 자기 업체 서류만 된다
                data: { docId: docId, imgId: imgId },
                success: (data) => {
                    if (!data.result) {
                        $j.Common.Util.swalert('시스템에러로 저장하지 못했습니다.');
                    }
                    location.reload();
                }
            });
        });
    }

    /**
     * 서류이미지 편집창을 띄운다.
     * 저장 뒤 어느 서류에 돌려놓을지는 G5['currentEditDocId'] 로 넘긴다 (서류 화면들 공용 규약).
     * @param num 서류번호
     * @param imgId 이미지번호
     */
    editPhoto(num, imgId) {
        if (!imgId) { $j.Common.Util.swalert(['편집할 이미지가 없습니다.', 'warning']); return; }
        G5['currentEditDocId'] = num;
        $j.F.ImageEditor.open(imgId);
    }

    /** [문서 완료로 설정] */
    setDone() {
        $.ajax({ type: 'POST', url: '/adm/ajax/doc/secret', data: { mb_no: this.mbNo }, success: function () {
            location.reload();
        } });
    }

    /* ── 서류 이동 ── */
    initMove() {
        const $root  = this.$root;
        const $type  = this.$type  = $root.find('.js-move-type');
        const $title = this.$title = $root.find('.js-move-title');
        const $go    = this.$go    = $root.find('.js-move-go');

        $root.on('click', '.js-move-mode', () => {
            if ($root.hasClass('is-moving')) { this.endMove(); return; }
            $root.addClass('is-moving');
            this.syncMove();
        });
        $root.on('click', '.js-move-cancel', () => this.endMove());
        $root.on('click', '.js-pick-all', (e) => {
            const $cards = $(e.currentTarget).closest('.md-group').find('.md-card');
            // 다 골라져 있으면 푼다
            $cards.toggleClass('is-picked', $cards.not('.is-picked').length > 0);
            this.syncMove();
        });
        $type.on('change', () => this.syncMove());
        $title.on('input', () => this.syncMove());

        $go.on('click', async () => {
            const nums = this.picked();
            const to   = this.isEtc() ? `기타 서류 「${$title.val().trim()}」` : $type.find(':selected').text();
            const ok = await $j.Ui.Dialog.confirm(`사진 ${nums.length}장을 ${to}(으)로 옮길까요?`, {
                desc: '사진은 그대로이고 서류 칸만 바뀝니다. 회원 앱의 서류 화면에도 바로 반영됩니다.',
                confirm: '옮기기',
            });
            if (!ok) return;

            $go.prop('disabled', true);
            $.post('/adm/ajax/doc/move', {
                mb_no: this.mbNo, nums: nums, type_num: $type.val(), title: $title.val().trim(),
            }).done((r) => {
                if (!r || !r.result) { $j.Common.Util.swalert([(r && r.message) || '옮기지 못했습니다.', 'warning']); this.syncMove(); return; }
                location.reload();
            }).fail(() => { $j.Common.Util.swalert(['옮기지 못했습니다. 잠시 후 다시 시도하세요.', 'error']); this.syncMove(); });
        });
    }

    picked() {
        return this.$root.find('.md-card.is-picked').map(function () { return $(this).data('num'); }).get();
    }

    isEtc() { return Number(this.$type.find(':selected').data('etc')) === 1; }

    syncMove() {
        const n = this.picked().length;
        this.$root.find('.js-pick-cnt').text(n);
        this.$title.toggleClass('is-on', this.isEtc());
        this.$go.prop('disabled', !n || !this.$type.val() || (this.isEtc() && !this.$title.val().trim()));
    }

    endMove() {
        this.$root.removeClass('is-moving').find('.md-card.is-picked').removeClass('is-picked');
        this.syncMove();
    }
}
